module.exports = __webpack_public_path__ + "img/big-dreams.56a9ec4.webp";